import { render, staticRenderFns } from "./CollegeDashboardDisplay.vue?vue&type=template&id=15486ee7&scoped=true&"
import script from "./CollegeDashboardDisplay.vue?vue&type=script&lang=js&"
export * from "./CollegeDashboardDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CollegeDashboardDisplay.vue?vue&type=style&index=0&id=15486ee7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15486ee7",
  null
  
)

export default component.exports